/**
 * Legacy App JS bundle
 * This replaces the webpack.mix.js app-2019.min.js concatenation
 * Imports all JS files from resources/js/default/
 *
 * NOTE: This module imports vendor.js to ensure proper dependency ordering.
 * Vendor scripts must be fully loaded before app scripts that depend on them.
 */

// Import vendor.js and await its exported promise
// This creates a proper ES module dependency, ensuring vendor.js runs first
import { vendorScriptsReady } from './vendor.js';

async function loadAppScripts() {
    // Wait for all vendor scripts (Bootstrap, Select2, etc.) to be fully loaded
    await vendorScriptsReady;

    // tsc.js MUST load first as it defines the Eskenazi namespace used by ezicut.js
    await import('./default/tsc.js');

    // numeric.js MUST load before ezicut.js as it defines jStepper plugin
    await import('./default/numeric.js');

    // Now load all other scripts in parallel
    return Promise.all([
        import('./default/affix.js'),
        import('./default/counter.js'),
        import('./default/cssua.js'),
        import('./default/eshop.js'),
        import('./default/eshop_delivery.js'),
        import('./default/ezicut.js'),
        import('./default/fancybox.js'),
        import('./default/flickity.js'),
        import('./default/global.js'),
        import('./default/jquery-ui.js'),
        import('./default/slider-news.js'),
        import('./default/sub-gamme.js'),
        import('./default/user-account.js'),
    ]);
}

// Start loading - the function awaits vendorScriptsReady first
loadAppScripts();
